export enum Ingredients{
    TOP_BREAD = 'top-bread',
    SALAD = 'salad',
    BACON = 'bacon',
    CHEESE = 'cheese',
    MEAT = 'meat',
    BOTTOM_BREAD = 'bottom-bread'
}